import React, { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

export interface TextContentChangePluginProps {
  onChange: (textContent: string) => void
}

export const OnTextContentChangePlugin: React.FC<TextContentChangePluginProps> = ({ onChange }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerTextContentListener((textContent) => onChange(textContent))
  }, [editor, onChange])

  return null
}
